import { createContext, useContext } from 'react';

const WaitingContext = createContext(null);

export const useWaiting = () => {
  const context = useContext(WaitingContext);
  if (!context) {
    throw new Error('useWaiting must be used within a WaitingProvider');
  }
  return context;
};

export default WaitingContext;
